/**
 * Created by Administrator on 2018/6/6.
 */
const state = {
}
const mutations = {
}
const actions = {

}
export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/loginMsg.js